import loadScript from 'sign_up/load_script'

export function isCaptchaChallenge (response) {
  return response.status === 405 && response.headers.get('x-amzn-waf-action') === 'captcha'
}

// Renders the AWS WAF CAPTCHA widget into container and resolves once the user solves it. The
// solved token is picked up by AwsWafIntegration.fetch on the next request.
export default async function solveCaptcha (container, { captchaUrl, captchaApiKey }) {
  await loadScript(captchaUrl)

  return new Promise((resolve, reject) => {
    window.AwsWafCaptcha.renderCaptcha(container, {
      apiKey: captchaApiKey,
      onSuccess: resolve,
      onError: reject
    })
  })
}
